<template>
	<div>
		<div class="p-layout-breadcrumb">
			<el-row type="flex" align="middle">
				<el-col :span="3">
					<h3>享玩甄选设置</h3>
				</el-col>
				<el-col :span="2">
					<el-button type="info" @click="handleAdd">新增</el-button>
				</el-col>
			</el-row>
		</div>
		<el-table :data="fetchList" :default-sort = "{prop: 'name', prop: 'description'}">
            <el-table-column prop="name" label="商品名称" sortable>
			</el-table-column>
            <el-table-column prop="description" label="描述" sortable>
			</el-table-column>
			<el-table-column inline-template :context="_self" width="150" label="操作">
				<span>
			                  <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
			                  <el-button @click="handleDelete($index, row)" type="text" size="small" v-if="Role === '1'">删除</el-button>
			        </span>
			</el-table-column>
		</el-table>
	
		<div class="page-footer">
                <el-button type="primary" @click="next" size="large">下一步</el-button>
        </div>

	</div>
</template>

<script>
	import {
		getVersions,
		getGlobalSettings,
		filterIndexVersions,
		getProductCategories,
		getProductTags,
		getProductDetails
	} from '../../api/version'
	
	export default {
		data() {
			return {
				fetchList: [],
				Role: sessionStorage.power,
				uptoken: { token: sessionStorage.token}
			}
        },
        
        created() {
            let currentData = this.$store.state.currentIndex
			this.fetchList = currentData.value.product
			console.log(this.fetchList, 'all')
        },

		methods: {
			handleAdd() {
				this.$router.push('/addShop')
			},
			next() {
                let currentData = this.$store.state.currentIndex
				if (currentData.value.product.length) {
					this.$router.push('/indexCatogrey')
				} else {
					this.$message({
						message: '请先设置享玩甄选',
						type: 'warning'
					});
				}
			},
			handleDelete(index, row) {
				this.$confirm('此操作将永久删除该Banner, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.fetchList.forEach( (item,index) => {
						if(item.name === row.name) {
							this.fetchList.splice(index, 1)
						}
					})
					
					let currentProduct = JSON.parse(JSON.stringify(this.fetchList))
					let currentData = this.$store.state.currentIndex

					currentData.value.product = currentProduct
					this.$store.commit('SETCURRENTINDEX', currentData);
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					// this.refresh()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			handleEdit(index, row) {
				console.log(row)
				this.$router.push('/editShop/' + row.name)
				//targetId
			}
		}
	}
</script>

<style>

	.user-pic {
		width: 50px;
		height: 50px;
		margin-top: 10px;
	}
	.avatar-uploader .el-upload {
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.avatar-uploader .el-upload:hover {
		border-color: #20a0ff;
	}
	
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.page-footer {
		margin-top: 60px;
		text-align: center;
	}
</style>




// WEBPACK FOOTER //
// ShopList.vue?5532314b